import { useRouter } from 'next/router';
import React, { useState } from 'react';
import {
  getPathForBabyNames,
  removeDefaultParams,
} from '../../../../Utils/helper';
import { Alphabets } from './styled';
import Link from 'next/link';
import { getSearchParams } from '../../../Parenting/common';
import { clickedSectionEvent } from '../../instrumentation/instrumentation';
import { getRouterLocale } from '../../../../Utils/i18Utils/constant';

export default React.memo(function AlphabetsSection({ detailPage }) {
  let alphabets = [];
  const [selected, setSelected] = useState();
  const router = useRouter();
  for (let k = 65; k < 91; k++) {
    let str = String.fromCharCode(k);
    alphabets.push(
      <li
        onClick={() => {
          alphabetSelected(k);
        }}
        key={k}
        className={selected == k ? 'active' : ''}
      >
        <Link
          href={{
            pathname: getPathForBabyNames(
              'starting-with/',
              detailPage,
              String.fromCharCode(k).toLowerCase(),
            ),
            query: removeDefaultParams(router.query),
          }}
          passHref
          locale={false}
          key={`alphabet-${k}`}
          onClick={(e) => {
            e.preventDefault();
            clickedSectionEvent(true, 'Browse by Letter', undefined, str);

            setTimeout(() => {
              router.push(
                getPathForBabyNames(
                  'starting-with/',
                  detailPage,
                  String.fromCharCode(k).toLowerCase(),
                ) + getSearchParams(),
                '',
                {
                  locale: getRouterLocale(router),
                },
              );
            }, [200]);
          }}
        >
          {str}
        </Link>
      </li>,
    );
  }
  const alphabetSelected = async (k) => {
    setSelected(k);
  };
  return (
    <div>
      <Alphabets>{alphabets}</Alphabets>
    </div>
  );
});
